import TeamRequestCardHelper from '../teamRequestCard.helper';

class TeamRequestCardActionsController {
  constructor() {
    this.teamRequestCardHelper = new TeamRequestCardHelper();
  }

  getTeamRequestCardActionsClasses() {
    const onlyButtons = this.teamRequestCardHelper.isRejectAccept(this.request) &&
                        !this.teamRequestCardHelper.isDiscard(this.request) &&
                        !this.teamRequestCardHelper.hasObservations(this.request);
    return {
      'team-request-card-actions': true,
      'only-buttons': onlyButtons
    };
  }
}

export default TeamRequestCardActionsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActions/teamRequestCardActions.controller.js